import { Tooltip } from 'antd';
import cx from 'classnames';
import { FC, useEffect, useMemo, useRef, useState } from 'react';
import styles from '../columns.module.scss';

interface InvoicePICCellProps {
  value: string;
}

export const InvoicePICCell: FC<InvoicePICCellProps> = ({ value }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const tooltipContent = useMemo(
    () => <div className={cx(styles['tooltipContent'])}>{value}</div>,
    [value]
  );

  useEffect(() => {
    const checkTruncation = () => {
      const element = contentRef.current;
      if (element) {
        setIsTruncated(element.scrollHeight > element.clientHeight);
      }
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [value]);

  return (
    <Tooltip
      overlayClassName={cx(styles['tooltipPicCell'])}
      title={isTruncated ? tooltipContent : ''}
      placement='bottomLeft'
      destroyTooltipOnHide
    >
      <div
        ref={contentRef}
        className={cx(styles['invoicePicCell'])}
        data-testid='invoice-pic-cell'
      >
        {value}
      </div>
    </Tooltip>
  );
};
